import React from "react";
import './Button.scss';

export default function Button({ children, textOnly, btnOutline, className, ...props }) {
    let cssClasses = textOnly ? 'advanced-text-button' : 'advanced-button';
    if (btnOutline) cssClasses = 'advanced-btn-outline';
    cssClasses += ' ' + className;
    return (
        <button className={cssClasses} {...props}>{children}</button>
    )
}